// extracted by mini-css-extract-plugin
export var discard = "_4d-3";
export var muiTooltipTooltip = "_4d-5";
export var notificationBar = "_4d-2";
export var saveButtonHoverSlotWrapper = "_4d-4";
export var show = "_4d-1";
export var spacer = "_4d-0";